import type { Assignment } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { BookCoverProps } from 'types';

export enum ASSIGNMENT_STATUSES {
  COMPLETE = 'COMPLETED',
  INCOMPLETE = 'IN_PROGRESS',
  NEW = 'NOT_STARTED',
  SKIPPED = 'SKIPPED',
}

export enum BUTTON_DIRECTIONS {
  NEXT = 'next',
  PREVOUS = 'previous',
}

export type AssignmentWithCover = Assignment & { cover: BookCoverProps };
